
import NativeClient from "@/client/native-client";
import { defineComponent, SetupContext } from "vue";

export default defineComponent({
  name: "PantrySearchListItem",
  props: {
    /**
     * レシピ画像
     */
    recipeImageUrl: {
      type: String
    },
    /**
     * レシピ名
     */
    recipeLabel: {
      type: String,
      required: true
    },
    recipeId: {
      type: Number
    },
    type: {
      type: String
    }
  },
  setup(props, context: SetupContext) {
    /**
     * ボタンが押されたことを通知する
     */
    const onClick = () => {
      context.emit("select-recipe", props.recipeId, props.type);
    };
    /**
     * 画像読み込みエラー発生
     */
    const onImageError = (event: Event) =>{
      NativeClient.sendDebugLog("PantrySearchListItem onImageError");
      if (event.target) {
        NativeClient.sendDebugLog("PantrySearchListItem onImageError target exist");
        (event.target as HTMLImageElement).src = require("@/assets/images/food_noimage.png");
      }
    };
    const isShow = () => {
      return props.recipeLabel != "";
    };
    return {
      onClick,
      onImageError,
      isShow
    };
  }
});
